module.exports = __webpack_public_path__ + "static/media/eth.c1fe0fc8.svg";